import { FocusEvent, useState } from 'react';
import NumberFormat, { NumberFormatProps } from 'react-number-format';
import { config } from '../../utils/config';
import { DEFAULT_DATE_FORMAT, getDate } from '../../utils/dates';
import { isEmpty } from '../../utils/getValidator';
import Input, { CustomInputProps } from './Input';

export type DateInputProps = Omit<NumberFormatProps, 'onChange'> &
  Omit<CustomInputProps, 'onChange'> & { onChange: (value: string) => void };

const DateInput = ({ onChange, onBlur, ...props }: DateInputProps) => {
  const initialValue = !isEmpty(props.value)
    ? getDate(props.value, DEFAULT_DATE_FORMAT, true).format(config.formats.date)
    : '';
  const [value, setValue] = useState(initialValue);

  return (
    <NumberFormat
      customInput={Input}
      mask="_"
      format={config.formats.date.replace(/[DMY]/g, '#')}
      {...props}
      value={value}
      onValueChange={({ formattedValue }) => {
        setValue(formattedValue);
        const date = getDate(formattedValue, config.formats.date, true);
        onChange(date.isValid() ? date.format(DEFAULT_DATE_FORMAT) : '');
      }}
      onBlur={(e: FocusEvent<HTMLInputElement>) => {
        onBlur?.(e);
        const date = getDate(value, config.formats.date, true);
        if (!date.isValid()) {
          setValue('');
        }
      }}
    />
  );
};

export default DateInput;
